var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 28C1.5 13.3886 13.3886 1.5 28 1.5C42.6114 1.5 54.5 13.3886 54.5 28C54.5 42.6114 42.6114 54.5 28 54.5C13.3886 54.5 1.5 42.6114 1.5 28Z",
    stroke: "#800080",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1916 22.0662L27.0248 37.2325C26.5698 37.6876 25.9725 37.9166 25.3752 37.9166C24.778 37.9166 24.1807 37.6876 23.7256 37.2325L16.1425 29.6494C15.2299 28.7372 15.2299 27.2623 16.1425 26.3502C17.0546 25.4376 18.5291 25.4376 19.4416 26.3502L25.3752 32.2838L38.8925 18.767C39.8046 17.8544 41.279 17.8544 42.1916 18.767C43.1038 19.6791 43.1038 21.1536 42.1916 22.0662Z",
    fill: "#800080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.77b4d1e03dcdf84035397dda68ec2233.svg";
export { ForwardRef as ReactComponent };